import { Trans } from '@lingui/macro'
import React from 'react'

import { InstallGatewayButton } from '../molecules/InstallGatewayButton'
import { WizardStep } from '../typings/types'

export const InstallGatewayStep: WizardStep = ({ account, onNext }) => {
  return <InstallGatewayButton account={account} onClick={onNext} />
}

InstallGatewayStep.getStepLabel = () => <Trans>Instalace brány</Trans>
